import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import moment from "moment";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { ParametersOrderPayPending } from "../../../../../shared/cw-backend/models/attendance/order-pay-pending";
import { Insurance } from "../../../../../shared/cw-backend/models/backend-definitions.module";
import { AttendanceListProvider } from "../../../../../shared/cw-backend/providers/attendance/attendance/attendance-list.provider";
import { CompanyListProvider } from "../../../../../shared/cw-backend/providers/organizational/company/company-list.provider";
import { PageOptions } from "../../../../../shared/cw-utils/cw-utils.service";

@Component({
    selector: "app-pay-pending",
    templateUrl: "./pay-pending.component.html",
    styleUrls: ["./pay-pending.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PayPendingComponent implements OnInit {
    loading: boolean = false;
    selectedTabIndex: number;
    typeControl = new FormControl("1");
    payPendingForm: FormGroup;
    orderPayPendingForm = new FormControl();
    //listagens
    companyList: Insurance[];
    orderPayPendingList = new Array<any>();

    //page options
    companyPageOptions: PageOptions;
    professionalPageOptions: PageOptions;
    planPageOptions: PageOptions;
    parametersOrderPayPending = new ParametersOrderPayPending();
    private _unsubscribeAll: Subject<any>;
    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;
    configEditor = {
        toolbar: [],
    };

    constructor(
        public dialogRef: MatDialogRef<PayPendingComponent>,
        private companyListProvider: CompanyListProvider,
        private AttendanceListProvider: AttendanceListProvider,
        private _formBuilder: FormBuilder,
        private fuseProgressBarModule: FuseProgressBarService,
        private _router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.companyPageOptions = new PageOptions();
        this.companyPageOptions.fieldSort = "name";
        this.companyPageOptions.page = 0;
        this.companyPageOptions.sizePage = 10;
        this.companyPageOptions.argument = "";

        this.parametersOrderPayPending.pageOptions = new PageOptions();
        this.parametersOrderPayPending.pageOptions.sizePage = 10;

        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.payPendingForm = this.createPayPendingForm();
        this.getAll();
        this.filterAll();
        this.ObservableDate();
    }

    dimiss() {
        this.dialogRef.close();
    }

    getAll() {
        this.getCompany();
        this.getOrderPayPending();
    }

    filterAll() {
        this.filterCompany();
        this.filterOrderPayPending();
    }

    getCompany() {
        this.companyListProvider
            .getPageSimpleList(this.companyPageOptions)
            .then((res) => {
                this.companyList = res.body.content;
            });
    }

    filterCompany() {
        this.payPendingForm.controls["company"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.companyPageOptions.argument = res.name;
                    this.parametersOrderPayPending.companyId = res.id;
                    this.getOrderPayPending();
                } else if (res && typeof res === "string") {
                    this.companyPageOptions.argument = res;
                } else {
                    this.companyPageOptions.argument = "";
                }

                this.getCompany();
            });
    }

    getOrderPayPending(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.parametersOrderPayPending.pageOptions.fieldSort =
                    event.active;
                this.parametersOrderPayPending.pageOptions.sortDirection =
                    event.direction;
                break;
            case "page":
                this.parametersOrderPayPending.pageOptions.page =
                    event.pageIndex;
                this.parametersOrderPayPending.pageOptions.sizePage =
                    event.pageSize;
                break;

            default:
                this.parametersOrderPayPending.pageOptions.page = 0;
                this.parametersOrderPayPending.pageOptions.sizePage = 10;
                break;
        }

        this.parametersOrderPayPending.pageOptions.fieldSort = "name";
        this.parametersOrderPayPending.pageOptions.sortDirection = "desc";

        this.parametersOrderPayPending.dateStart = moment(
            this.payPendingForm.controls["start"].value,
        ).format("YYYY-MM-DD");
        this.parametersOrderPayPending.dateFinish = moment(
            this.payPendingForm.controls["end"].value,
        ).format("YYYY-MM-DD");

        this.AttendanceListProvider.getOrdersPayPending(
            this.parametersOrderPayPending,
        ).then((res) => {
            this.fuseProgressBarModule.hide();
            this.totalElements = res.body.totalElements;
            this.pagina = res.body.number;
            this.orderPayPendingList = res.body.content;
        });
    }

    filterOrderPayPending() {
        this.orderPayPendingForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.parametersOrderPayPending.pageOptions.argument =
                        res.name;
                } else if (res && typeof res === "string") {
                    this.parametersOrderPayPending.pageOptions.argument = res;
                } else {
                    this.parametersOrderPayPending.pageOptions.argument = "";
                }

                this.getOrderPayPending();
            });
    }

    displayCompanyFn(company?: any): string | undefined {
        if (!company) {
            return "";
        }
        if (company.name) {
            return company.name;
        }
        return company.name;
    }

    createPayPendingForm(): FormGroup {
        return this._formBuilder.group({
            company: new FormControl(null),
            end: new FormControl(moment().endOf("month").format("YYYY-MM-DD")),
            start: new FormControl(
                moment().startOf("month").format("YYYY-MM-DD"),
            ),
        });
    }

    displayPerformerFn(performer?: any): string | undefined {
        if (!performer) {
            return "";
        }
        if (performer.professional) {
            return performer.professional.person.name;
        }
        return performer.person.name;
    }

    ObservableDate() {
        this.payPendingForm.controls["end"].valueChanges
            .pipe()
            .subscribe((res) => {
                if (res) {
                    let dateStart = moment(
                        this.payPendingForm.controls["start"].value,
                    ).format("YYYY-MM-DD");
                    let dateEnd = moment(res).format("YYYY-MM-DD");

                    this.parametersOrderPayPending.dateStart = dateStart;
                    this.parametersOrderPayPending.dateFinish = dateEnd;
                    this.getOrderPayPending();
                }
            });
    }

    cleanDateRange() {
        this.payPendingForm.controls["end"].setValue(null, {
            emitEvent: false,
        });
        this.payPendingForm.controls["start"].setValue(null, {
            emitEvent: false,
        });
        this.parametersOrderPayPending.dateStart = null;
        this.parametersOrderPayPending.dateFinish = null;
        this.getOrderPayPending();
    }

    async navigateOs(patientId: any, orderId: any, event: Event) {
        this.stopPropagation(event);

        this._router.navigate([
            `operacional/recepcao/os/manter/${patientId}/${orderId}`,
        ]);

        this.dialogRef.close();
    }

    stopPropagation(event: Event) {
        event.preventDefault();
        event.stopPropagation();
    }
}
